// extracted by mini-css-extract-plugin
export default {"container_btn":"BackButton_container_btn__ANmJq","submit_form_btn":"BackButton_submit_form_btn__2Uye5"};